export default __webpack_public_path__ + "static/media/HELP.4a54f575.svg";